<div class="editor-wrapper">
  <!-- Top bar -->
  <div class="editor-topbar">
    <div class="editor-topbar-left">
      <svg width="22" height="22" fill="none" stroke="#3b82f6" stroke-width="2" viewBox="0 0 24 24"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/><polyline points="10 9 9 9 8 9"/></svg>
      <span class="editor-topbar-title">{{ editId ? 'Edit Document' : 'New Document' }}</span>
      <span class="editor-type-badge" [class.employee]="type === 'employee'" [class.client]="type === 'client'">{{ type | titlecase }}</span>
      <span *ngIf="department" class="editor-dept-badge">{{ department }}</span>
    </div>
    <div class="editor-topbar-right">
      <div *ngIf="saveSuccess" class="save-indicator success">&#10003; Saved</div>
      <div *ngIf="saveError" class="save-indicator error">{{ saveError }}</div>
      <button class="btn-cancel" routerLink="/documents">Cancel</button>
      <button class="btn-preview" (click)="openPreview()">
        <svg width="15" height="15" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>
        Preview
      </button>
      <button class="btn-save" (click)="saveDocument()" [disabled]="isSaving">
        <svg *ngIf="!isSaving" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"/><polyline points="17 21 17 13 7 13 7 21"/><polyline points="7 3 7 8 15 8"/></svg>
        {{ isSaving ? 'Saving...' : 'Save Document' }}
      </button>
    </div>
  </div>

  <!-- Document area -->
  <div class="editor-body">
    <!-- Sidebar meta -->
    <div class="editor-sidebar" [style.width.px]="sidebarWidth">
      <div class="meta-section">
        <div class="meta-label">Title</div>
        <input class="meta-input" [(ngModel)]="title" placeholder="Enter document title..." />
      </div>
      <div class="meta-section">
        <div class="meta-label">Department</div>
        <select class="meta-input" [(ngModel)]="department">
          <option value="" disabled>Select department...</option>
          <option value="HR">HR</option>
          <option value="Accounting">Accounting</option>
        </select>
      </div>
      <div class="meta-section">
        <label class="sig-checkbox-label">
          <input type="checkbox" [(ngModel)]="requiresSignature" />
          <span>Requires signature</span>
        </label>
        <div class="sig-checkbox-hint">When enabled, recipients must sign this document before submission.</div>
      </div>
      <div class="meta-section">
        <div class="meta-label">Tip</div>
        <div class="meta-tip">Use <code>{{ '{' }}employee_name{{ '}' }}</code> as placeholders for dynamic values.</div>
      </div>

      <!-- Variables panel -->
      <div class="meta-section vars-section">
        <button class="vars-toggle" (click)="showVariables = !showVariables">
          <svg width="13" height="13" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><polyline points="16 18 22 12 16 6"/><polyline points="8 6 2 12 8 18"/></svg>
          Insert Variable
          <svg class="vars-chevron" [class.open]="showVariables" width="12" height="12" fill="none" stroke="currentColor" stroke-width="2.5" viewBox="0 0 24 24"><polyline points="6 9 12 15 18 9"/></svg>
        </button>
        <div class="vars-panel" *ngIf="showVariables">
          <input class="vars-search" [(ngModel)]="varSearch" placeholder="Search variables..." />
          <div class="vars-groups">
            <div class="vars-group" *ngFor="let group of variableGroups">
              <div class="vars-group-label">{{ group.label }}</div>
              <button class="var-item" *ngFor="let v of group.vars" (mousedown)="$event.preventDefault(); insertVariable(v.token)" [title]="v.description">
                <code class="var-token">{{ v.token }}</code>
                <span class="var-desc">{{ v.description }}</span>
              </button>
            </div>
            <div class="vars-empty" *ngIf="variableGroups.length === 0">No matching variables.</div>
          </div>
        </div>
      </div>
    </div>

    <!-- Drag-to-resize handle -->
    <div class="editor-resize-handle" (mousedown)="onResizeMouseDown($event)" title="Drag to resize"></div>

    <!-- Main editor -->
    <div class="editor-main">
      <!-- Toolbar row -->
      <div class="editor-toolbar-row">
        <button class="toolbar-extra-btn" (mousedown)="$event.preventDefault()" (click)="pasteWithFormatting()" title="Paste and preserve formatting">
          <svg width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"/><rect x="8" y="2" width="8" height="4" rx="1"/></svg>
          Paste
        </button>
        <button class="toolbar-extra-btn" (mousedown)="$event.preventDefault()" (click)="pasteAsPlainText()" title="Paste as plain text">
          <svg width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"/><rect x="8" y="2" width="8" height="4" rx="1"/></svg>
          Plain Text
        </button>
        <label class="toolbar-extra-btn upload" title="Upload image">
          <svg width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><polyline points="21 15 16 10 5 21"/></svg>
          Image
          <input type="file" accept="image/*" style="display:none" (change)="uploadImage($event)" />
        </label>
        <label class="toolbar-extra-btn upload" title="Import Word / Google Docs (.docx)">
          <svg width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="17 8 12 3 7 8"/><line x1="12" y1="3" x2="12" y2="15"/></svg>
          {{ docxUploading ? 'Importing...' : 'Import .docx' }}
          <input type="file" accept=".docx,application/vnd.openxmlformats-officedocument.wordprocessingml.document" style="display:none" [disabled]="docxUploading" (change)="uploadDocx($event)" />
        </label>
        <div class="toolbar-divider"></div>
        <!-- Columns dropdown -->
        <div class="toolbar-columns-wrap" style="position:relative;display:inline-flex;">
          <button class="toolbar-extra-btn" (mousedown)="$event.preventDefault()" (click)="$event.stopPropagation(); showColumnsMenu = !showColumnsMenu" title="Insert multi-column layout">
            <svg width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><rect x="3" y="3" width="7" height="18" rx="1"/><rect x="14" y="3" width="7" height="18" rx="1"/></svg>
            Columns
            <svg style="margin-left:2px" width="10" height="10" fill="none" stroke="currentColor" stroke-width="2.5" viewBox="0 0 24 24"><polyline points="6 9 12 15 18 9"/></svg>
          </button>
          <div *ngIf="showColumnsMenu" style="position:absolute;top:100%;left:0;z-index:100;background:#fff;border:1px solid #e2e8f0;border-radius:6px;box-shadow:0 4px 12px rgba(0,0,0,0.1);min-width:140px;padding:4px 0;margin-top:2px;">
            <button style="display:flex;align-items:center;gap:8px;width:100%;padding:7px 14px;font-size:13px;background:none;border:none;cursor:pointer;color:#1e293b;" (mousedown)="$event.preventDefault()" (click)="$event.stopPropagation(); insertColumns(2)">
              <svg width="13" height="13" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><rect x="3" y="3" width="7" height="18" rx="1"/><rect x="14" y="3" width="7" height="18" rx="1"/></svg>
              2 Columns
            </button>
            <button style="display:flex;align-items:center;gap:8px;width:100%;padding:7px 14px;font-size:13px;background:none;border:none;cursor:pointer;color:#1e293b;" (mousedown)="$event.preventDefault()" (click)="$event.stopPropagation(); insertColumns(3)">
              <svg width="13" height="13" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><rect x="3" y="3" width="5" height="18" rx="1"/><rect x="10" y="3" width="5" height="18" rx="1"/><rect x="17" y="3" width="5" height="18" rx="1"/></svg>
              3 Columns
            </button>
          </div>
        </div>
        <div class="toolbar-divider"></div>
        <ngx-editor-menu [editor]="editor" [toolbar]="toolbar"></ngx-editor-menu>
      </div>

      <!-- Editor content -->
      <div class="editor-content-wrap">
        <ngx-editor [editor]="editor" [(ngModel)]="content" placeholder="Start typing your document..."></ngx-editor>
      </div>
    </div>
  </div>
</div>

<!-- Preview modal -->
<div class="preview-backdrop" *ngIf="showPreview" (click)="showPreview = false">
  <div class="preview-modal" (click)="$event.stopPropagation()">
    <div class="preview-modal-header">
      <h3>{{ title || 'Untitled Document' }}</h3>
      <button class="preview-close-btn" (click)="showPreview = false" title="Close">
        <svg width="18" height="18" fill="none" stroke="currentColor" stroke-width="2.5" viewBox="0 0 24 24"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
      </button>
    </div>
    <div class="preview-modal-body" [innerHTML]="safeContent"></div>
  </div>
</div>
